module.exports = __webpack_public_path__ + "static/media/bar.11a3e8f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/bar.svg
// module id = 752
// module chunks = 0